import { JobsDynamicPageModel, IJobsDynamicPage } from "@core/models";

export const dynamicPages = [
  {
    [IJobsDynamicPage.id]: "hotellerie-restauration",
    [IJobsDynamicPage.label]: "Secteur Restauration-Hotellerie",
    [IJobsDynamicPage.img]: "https://picsum.photos/id/1060/874/367",
    [IJobsDynamicPage.imgTitle]: "Offres d'emploi en h\u00f4tellerie-restauration",
  },
  {
    [IJobsDynamicPage.id]: "vente-logistique",
    [IJobsDynamicPage.label]: "Secteur Vente / Logistique",
    [IJobsDynamicPage.img]: "https://picsum.photos/id/20/874/367",
    [IJobsDynamicPage.imgTitle]: "Offres d'emploi en vente-logistique",
  },
].map((el) => new JobsDynamicPageModel(el));

export const popularSearches = [
  {
    [IJobsDynamicPage.id]: "employe-polyvalent",
    [IJobsDynamicPage.label]: "Employ\u00e9 Polyvalent",
    [IJobsDynamicPage.img]: "https://picsum.photos/id/3/874/367",
    [IJobsDynamicPage.imgTitle]: "Offres d'emploi d'employ\u00e9 polyvalent",
  },
  {
    [IJobsDynamicPage.id]: "missions-extra",
    [IJobsDynamicPage.label]: "Mission Extra",
    [IJobsDynamicPage.img]: "https://picsum.photos/id/30/874/367",
    [IJobsDynamicPage.imgTitle]: "Offres de missions en extra en h\u00f4tellerie-restauration et vente",
  },
  {
    [IJobsDynamicPage.id]: "preparateur-de-commande",
    [IJobsDynamicPage.label]: "Pr\u00e9parateur de commande",
    [IJobsDynamicPage.img]: "https://picsum.photos/id/312/874/367",
    [IJobsDynamicPage.imgTitle]: "Offres d'emploi de pr\u00e9parateur de commande",
  },
].map((el) => new JobsDynamicPageModel(el));

export const dynamicPageData = new JobsDynamicPageModel({
  [IJobsDynamicPage.img]: "https://picsum.photos/id/30/874/367",
  [IJobsDynamicPage.imgTitle]: "Offres d'emploi en IDF",
  [IJobsDynamicPage.title]: "Les meilleurs jobs CDI, saisonniers et extra \u00e0 Paris et ses alentours",
  [IJobsDynamicPage.subText]:
    "<h2>Test</h2><p>Donec sed felis sed tortor elementum dignissim et eget nisi. Cras convallis id ipsum vitae interdum. Fusce feugiat elementum hendrerit. Sed bibendum risus ut blandit sollicitudin. Nullam placerat posuere arcu. Mauris ac feugiat risus, nec consectetur nunc. Sed placerat nulla et massa facilisis, non rhoncus nisi commodo.</p>",
  [IJobsDynamicPage.type]: "region",
  [IJobsDynamicPage.label]: "\u00cele-de-France",
});
